<div mat-dialog-title>Assign Accounts to Portfolio<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-dialog-content>
    <div class="nameHeader">Accounts: {{portfolioAccounts.length}} selected</div>
      <div class="block">
        <irb-inventory-grid
              [style.width] = "'100%'"
              [style.height] = "'240px'"
              [showSideBar] = "false"
              [gridOptions] = "gridOptions"
              [rowData] = 'portfolioAccounts'
              (gridReady) = "onGridReady($event)"></irb-inventory-grid>
      </div>

      <table width="100%">
        <tr>
            <td>Assign to</td>
            <td>
                <irb-dropdown-search #portfolioDropdown (search)="getPortfolios($event)" (selection)="setPortfolioTarget($event)" size="30"></irb-dropdown-search>
                <button class="btn-medium-secondary btn-spacer" (click)="createNewPortfolio()">New Portfolio</button>
            </td>
        </tr>
      </table>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button class="btn-medium-primary" [disabled]="!portfolioTarget" (click)="assignAccounts()">Continue</button>
  </mat-dialog-actions>
